import { DataHoraDTO } from "../../dtos/data-hora-dto";
import { PacienteDTO } from "../../dtos/paciente-dto";
import { Filial } from "../../filial/filial";
import { Paciente } from "../../paciente/paciente";
import { PlanoSaude } from "../../plano-saude/plano-saude";
import { Procedimento } from "../../procedimento/procedimento";
import { ProcedimentoConsulta } from "../../procedimento/procedimento-consulta/procedimento-consulta";
import { FechamentoMarcacao } from "../fechamento-marcacao";
import { MotivoCancelamentoMarcacao } from "../motivo-cancelamento-marcacao";
import { TipoMarcacaoEnum } from "../../enums/tipo-marcacao-enum";
import { MarcacaoConsultaPK } from "./pks/marcacao-consulta-pk";

export class MarcacaoConsulta {

    public static readonly STATUS_AGENDADO: string = 'A'

    public static readonly STATUS_FINALIZADO: string = 'F';

    public static readonly STATUS_CANCELADO: string = 'C';

    pk: MarcacaoConsultaPK = new MarcacaoConsultaPK();

    dataCriacaoConsulta: Date = new Date();

    horaAtendimento: string = '';

    status: string = '';

    filial: Filial = new Filial();

    paciente: Paciente = new Paciente();

    pacienteSelecionado: PacienteDTO = new PacienteDTO();

    planoSaude: PlanoSaude = new PlanoSaude();

    procedimentoConsulta: ProcedimentoConsulta = new ProcedimentoConsulta();

    procedimento: Procedimento = new Procedimento();

    idMedico: number = 0;

    nomeMedico: string = '';

    idMedicoSolicitante: number | null = null;

    nomeMedicoSolicitante: string | null = null;

    cobrarProcedimentoConsulta: boolean = false;

    listaDatasDisponiveis: Array<DataHoraDTO> = [];

    listaDatasNaoDisponiveis: Array<Date> = [];

    melhorData: Date = new Date();

    melhorHora: string = '';

    dataInicioMarcacao: Date = new Date();

    dataFimMarcacao: Date = new Date;

    marcacaoSelecionada: boolean = false;

    loginUserMarcacaoConsulta: string | null = null;

    portadorNecessidade: boolean = false;

    indPeriodoVolta: boolean = false;

    motivoCancelamentoMarcacao: MotivoCancelamentoMarcacao = new MotivoCancelamentoMarcacao();

    fechamentoMarcacao: FechamentoMarcacao = new FechamentoMarcacao();

    comprovanteSMSEnviado: boolean = false;

    comprovanteSMSEnviadoAutomaticamente: boolean = false;

    tipoMarcacao: TipoMarcacaoEnum = TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA;

    qtdDiasAgendaMedico: number = 0;

    constructor() {
    }

}
